import { ref } from 'vue';

export function useCalendarDialog(options: { closeToolsMenu: () => void; loadTimeline: () => Promise<void> }) {
  const calendarDialogOpen = ref(false);

  async function openCalendarDialog() {
    options.closeToolsMenu();
    await options.loadTimeline();
    calendarDialogOpen.value = true;
  }
  function closeCalendarDialog() { calendarDialogOpen.value = false; }

  return { calendarDialogOpen, openCalendarDialog, closeCalendarDialog };
}
